import React from "react";
import { Text } from "@zorni/components-lib";
import { useTranslation } from "react-i18next";

const RelaunchUser = ({ user }) => {
  const { t } = useTranslation();

  return (
    <Text type="text">
      {t("manageUsers.modal.relaunchPopup")} {user?.email || ""}
    </Text>
  );
};

export default RelaunchUser;
